import styled from "styled-components";
import { media } from "src/layouts/utils";
import { colorBrandPrimary } from "src/global.style";
import { isIOS, isMacOs } from "react-device-detect";
import { Button } from "veloe-ds";

export const Container = styled.div`
  max-width: 26.25rem;
  min-width: 13rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CardBody = styled.div`
  z-index: 1;
  width: 16.5rem;
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 1rem;
  overflow: hidden;
  opacity: 1;
`;

export const BenefitContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Benefits = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;

  hr {
    width: 100%;
    border: 0;
    border-top: 2px solid rgb(88, 83, 128);
    opacity: 0.16;
  }
`;
export const Benefit = styled.div`
  font-family: ${(props) => props.bold && '"Work Sans"'};
  font-size: ${(props) => (props.bold ? "1.25rem" : "1rem")};
  color: ${({ blur }) => (blur ? "transparent" : colorBrandPrimary.marine)};
  width: 100%;
  text-align: left;
  text-shadow: ${({ blur }) =>
    blur ? `0 0 8px ${colorBrandPrimary.marine}` : "none"};
`;

export const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  background-color: ${(props) =>
    props.index % 2 === 0 ? "#FFFFFF" : "#F7F7FC"};
  padding: 16px 16px 16px 0;
  gap: 0.75rem;
`;

export const CardFooter = styled.div`
  width: 16.5rem;
  height: auto;
  p {
    font-family: "Open Sans";
    font-weight: normal;
    font-size: 0.9rem;
    color: #353536;
    padding: 1.5rem 0 1.7rem;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
`;

export const CustomButtom = styled(Button)`
  font-family: "Work Sans" !important;
  font-weight: 700;
  .label {
    ${(isIOS || isMacOs) &&
      `
      top: 0;
    `}
  }
  ${media.phone`
    width: 134px !important;
`}
  ${media.smallPhone`
  width: 134px !important;
  `}
`;
